<div class="row">
    <div class="col-12">
        <div class="card">
            <!-- .left-right-aside-column-->
            <div class="contact-page-aside">
                <!-- .left-aside-column-->
                <div class="left-aside bg-light-part">
                    <ul class="list-style-none" *ngIf="!isLoader">
                        <li class="box-label">
                            <a href="javascript:void(0)">All Contacts<span>123</span></a>
                        </li>
                        <li class="divider p-0"> </li>
                        <li class="d-flex"><a class="mr-5" href="javascript:void(0)" (click)="onClickRole(null)">All</a>

                        </li>
                        <!-- All Roles -->
                        <li *ngFor="let role of roles">
                            <div class="d-flex align-items-center">
                              <a href="javascript:void(0)" (click)="onClickRole(role.name)">{{role.name}}</a>
                                <a (click)="delet(role._id)" type="submit" class="btn ml-auto waves-effect"><i
                                        class="fas fa-trash fa-lg text-danger"></i></a>
                                </div>
                      </li>

                        <li>
                          <a (click)="onAddNewRole()" class="btn p--2 mt-2 btn-info text-white">+ Create
                                NewLabel</a>
                              </li>

                                <loader *ngIf="isLoader"></loader>
                    </ul>
                </div>
                <!-- /.left-aside-column-->
                <div class="right-aside ">
                    <div class="right-page-header">
                        <div class="d-flex">
                            <div class="align-self-center">
                                <h4 class="card-title m-t-10">Contacts / Employee List </h4>
                            </div>
                            <div class="ml-auto">
                                <input type="text" (keyup)="getEmployees()" [(ngModel)]="searchQuery" id="demo-input-search2" placeholder="search contacts" class="form-control"> </div>
                        </div>
                    </div>
                    <button type="button" class="btn btn-info btn-rounded m-t-10 float-right" data-toggle="modal" data-target="#add-contact" (click)='onAddNew()'>Add New Contact</button>


                    <!-- Add New Employee Popup Model -->
                    <ng-template #createModal>
                        <div class="modal-header">
                            <h4 class="modal-title text-primary" id="myModalLabel">Add New Contact</h4>
                            <a (click)="onClose()" type="button" class="close">×</a>
                        </div>
                        <app-add-employee (save)="save($event)"></app-add-employee>
                    </ng-template>

                    <div class="table-responsive">
                        <div *ngIf="employees.length == 0" class="align-self-center">
                            <h4 class="card-title m-t-10"> No Employee Record! Please add Records </h4>
                        </div>
                        <table *ngIf="employees.length > 0 && !isLoader" id="demo-foo-addrow" class="table no-wrap table-bordered m-t-30 table-hover contact-list" data-paging="true" data-paging-size="7">
                            <thead>
                                <tr>
                                    <th>No</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Phone</th>
                                    <th>Role</th>
                                    <!-- <th>Joining date</th> -->
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let e of employees;let i = index">
                                    <td>{{(page * limit ) + i + 1}}</td>
                                    <td>{{e.name}}</td>
                                    <td>{{e.email}}</td>
                                    <td>{{e.phone}}</td>
                                    <td><span class="label label-danger">{{e.role}}</span> </td>
                                    <!-- <td>{{e.joiningdate | date}}</td> -->
                                    <td class="text-center"><a (click)="deletEmployee(e._id)" href="javascript:void(0)"><i class="fas fa-trash fa-lg text-danger"></i></a></td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr class="footable-paging">
                                    <td colspan="8">
                                        <div class="footable-pagination-wrapper">
                                            <ul class="pagination justify-content-center" *ngIf="totalCount > limit">
                                                <li class="page-item" *ngIf="page > 0">
                                                    <a class="page-link" (click)="onClickPage(page - 1 )" href="javascript:void(0)" aria-label="Previous">
                                                        <span aria-hidden="true">&laquo;</span>
                                                        <span class="sr-only">Previous</span>
                                                    </a>
                                                </li>

                                                <li class="page-item" [ngClass]="{'active': page == 0}" (click)="onClickPage(0)" *ngIf="(totalCount/limit) >= 0">
                                                    <a class="page-link" href="javascript:void(0)">1</a>
                                                </li>


                                                <li class="page-item" [ngClass]="{'active': page == 1}" *ngIf="(totalCount/limit) >= 1">
                                                    <a class="page-link" href="javascript:void(0)" (click)="onClickPage(1)">2</a>
                                                </li>


                                                <li class="page-item" [ngClass]="{'active': page == 2}" *ngIf="(totalCount/limit) >= 2">
                                                    <a class="page-link" href="javascript:void(0)" (click)="onClickPage(2)">3</a>
                                                </li>

                                                <li class="page-item" [ngClass]="{'active': page > 2}" *ngIf="((totalCount/limit) > 3) && (totalCount > (limit*(page+1)))">
                                                    <a class="page-link" (click)="onClickPage(page + 1 )" href="javascript:void(0)" aria-label="Next">
                                                        <span aria-hidden="true">&raquo;</span>
                                                        <span class="sr-only">Next</span>
                                                    </a>
                                                </li>
                                            </ul>
                                            <div class="divider"></div><span class="label label-primary">{{employees.length}} of {{totalCount}}</span>
                                        </div>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                        <loader *ngIf="isLoader"></loader>
                    </div>
                    <!-- .left-aside-column-->
                </div>
                <!-- /.left-right-aside-column-->
            </div>
        </div>
    </div>
</div>
<!-- ============================================================== -->
<!-- End PAge Content -->
<!-- ============================================================== -->


<!-- Create Role Modal -->
<ng-template #createRoleModal>
  <div class="modal-header">
      <h4 class="modal-title text-primary" id="myModalLabel">Add Label</h4>
      <a (click)="onClose()" type="button" class="close">×</a>
  </div>

  <div (keyup.enter)="onAddNewRoleToDB()" class="modal-body">
      <form [formGroup]="form" class="form-horizontal">
          <div class="form-group">
              <!-- Role Name Input -->
              <label class="col-md-12 mb-3">Name of Role</label>
              <div class="col-md-12">
                  <input formControlName="name" type="text" class="form-control" placeholder="Type role name">
                  <small *ngIf="isFormSubmitted && f.name.errors && f.name.errors.required" class="text-danger">
                      Enter a name
                  </small>
              </div>
          </div>
      </form>
  </div>
  <div class="modal-footer">

      <a (click)="onAddNewRoleToDB()" type="submit" class="btn btn-info text-white waves-effect" data-dismiss="modal">Save</a>

      <a (click)="onClose()" type="button" class="btn btn-default waves-effect">Cancel</a>

  </div>
</ng-template>
